<template lang="pug">
modal(:max-width="600")
	.card
		.card-header
			span Selecciona icono
			.close(@click="$emit('close')") &times;
		.card-body.text-left
			.form-group
				label.label Filtrar
				input.form-control(v-model="filtro")
			.contenedor-iconos
				.icono(
					v-for="icono in listado"
					@click="seleccionar(icono)"
				)
					span(:class="'fa fa-' + icono.id")
					div {{ icono.name }}
</template>

<script>
export default {
	data () {
		return {
			filtro: '',
			iconos: [
				{
					name: 'Glass',
					id: 'glass',
					unicode: 'f000',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Music',
					id: 'music',
					unicode: 'f001',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Search',
					id: 'search',
					unicode: 'f002',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Envelope Outlined',
					id: 'envelope-o',
					unicode: 'f003',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Heart',
					id: 'heart',
					unicode: 'f004',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Star',
					id: 'star',
					unicode: 'f005',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Star Outlined',
					id: 'star-o',
					unicode: 'f006',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'User',
					id: 'user',
					unicode: 'f007',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Film',
					id: 'film',
					unicode: 'f008',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'th-large',
					id: 'th-large',
					unicode: 'f009',
					created: 1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'th',
					id: 'th',
					unicode: 'f00a',
					created: 1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'th-list',
					id: 'th-list',
					unicode: 'f00b',
					created: 1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'Check',
					id: 'check',
					unicode: 'f00c',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Times',
					id: 'times',
					unicode: 'f00d',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Search Plus',
					id: 'search-plus',
					unicode: 'f00e',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Search Minus',
					id: 'search-minus',
					unicode: 'f010',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Power Off',
					id: 'power-off',
					unicode: 'f011',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'signal',
					id: 'signal',
					unicode: 'f012',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'cog',
					id: 'cog',
					unicode: 'f013',
					created: 1,
					aliases: [
						'gear'
					],
					categories: [
						'Web Application Icons',
						'Spinner Icons'
					]
				},
				{
					name: 'Trash Outlined',
					id: 'trash-o',
					unicode: 'f014',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'home',
					id: 'home',
					unicode: 'f015',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'File Outlined',
					id: 'file-o',
					unicode: 'f016',
					created: 1,
					categories: [
						'Text Editor Icons',
						'File Type Icons'
					]
				},
				{
					name: 'Clock Outlined',
					id: 'clock-o',
					unicode: 'f017',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'road',
					id: 'road',
					unicode: 'f018',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Download',
					id: 'download',
					unicode: 'f019',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Arrow Circle Outlined Down',
					id: 'arrow-circle-o-down',
					unicode: 'f01a',
					created: 1,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Arrow Circle Outlined Up',
					id: 'arrow-circle-o-up',
					unicode: 'f01b',
					created: 1,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'inbox',
					id: 'inbox',
					unicode: 'f01c',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Play Circle Outlined',
					id: 'play-circle-o',
					unicode: 'f01d',
					created: 1,
					categories: [
						'Video Player Icons'
					]
				},
				{
					name: 'Repeat',
					id: 'repeat',
					unicode: 'f01e',
					created: 1,
					aliases: [
						'rotate-right'
					],
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'refresh',
					id: 'refresh',
					unicode: 'f021',
					created: 1,
					categories: [
						'Web Application Icons',
						'Spinner Icons'
					]
				},
				{
					name: 'list-alt',
					id: 'list-alt',
					unicode: 'f022',
					created: 1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'lock',
					id: 'lock',
					unicode: 'f023',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'flag',
					id: 'flag',
					unicode: 'f024',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'headphones',
					id: 'headphones',
					unicode: 'f025',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'volume-off',
					id: 'volume-off',
					unicode: 'f026',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'volume-down',
					id: 'volume-down',
					unicode: 'f027',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'volume-up',
					id: 'volume-up',
					unicode: 'f028',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'qrcode',
					id: 'qrcode',
					unicode: 'f029',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'barcode',
					id: 'barcode',
					unicode: 'f02a',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'tag',
					id: 'tag',
					unicode: 'f02b',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'tags',
					id: 'tags',
					unicode: 'f02c',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'book',
					id: 'book',
					unicode: 'f02d',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'bookmark',
					id: 'bookmark',
					unicode: 'f02e',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'print',
					id: 'print',
					unicode: 'f02f',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'camera',
					id: 'camera',
					unicode: 'f030',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'font',
					id: 'font',
					unicode: 'f031',
					created: 1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'bold',
					id: 'bold',
					unicode: 'f032',
					created: 1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'italic',
					id: 'italic',
					unicode: 'f033',
					created: 1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'text-height',
					id: 'text-height',
					unicode: 'f034',
					created: 1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'text-width',
					id: 'text-width',
					unicode: 'f035',
					created: 1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'align-left',
					id: 'align-left',
					unicode: 'f036',
					created: 1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'align-center',
					id: 'align-center',
					unicode: 'f037',
					created: 1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'align-right',
					id: 'align-right',
					unicode: 'f038',
					created: 1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'align-justify',
					id: 'align-justify',
					unicode: 'f039',
					created: 1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'list',
					id: 'list',
					unicode: 'f03a',
					created: 1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'Outdent',
					id: 'outdent',
					unicode: 'f03b',
					created: 1,
					aliases: [
						'dedent'
					],
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'Indent',
					id: 'indent',
					unicode: 'f03c',
					created: 1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'Video Camera',
					id: 'video-camera',
					unicode: 'f03d',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Picture Outlined',
					id: 'picture-o',
					unicode: 'f03e',
					created: 1,
					aliases: [
						'photo',
						'image'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'pencil',
					id: 'pencil',
					unicode: 'f040',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'map-marker',
					id: 'map-marker',
					unicode: 'f041',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'adjust',
					id: 'adjust',
					unicode: 'f042',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'tint',
					id: 'tint',
					unicode: 'f043',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Pencil Square Outlined',
					id: 'pencil-square-o',
					unicode: 'f044',
					created: 1,
					aliases: [
						'edit'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Share Square Outlined',
					id: 'share-square-o',
					unicode: 'f045',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Check Square Outlined',
					id: 'check-square-o',
					unicode: 'f046',
					created: 1,
					categories: [
						'Web Application Icons',
						'Form Control Icons'
					]
				},
				{
					name: 'Arrows',
					id: 'arrows',
					unicode: 'f047',
					created: 1,
					categories: [
						'Web Application Icons',
						'Directional Icons'
					]
				},
				{
					name: 'step-backward',
					id: 'step-backward',
					unicode: 'f048',
					created: 1,
					categories: [
						'Video Player Icons'
					]
				},
				{
					name: 'fast-backward',
					id: 'fast-backward',
					unicode: 'f049',
					created: 1,
					categories: [
						'Video Player Icons'
					]
				},
				{
					name: 'backward',
					id: 'backward',
					unicode: 'f04a',
					created: 1,
					categories: [
						'Video Player Icons'
					]
				},
				{
					name: 'play',
					id: 'play',
					unicode: 'f04b',
					created: 1,
					categories: [
						'Video Player Icons'
					]
				},
				{
					name: 'pause',
					id: 'pause',
					unicode: 'f04c',
					created: 1,
					categories: [
						'Video Player Icons'
					]
				},
				{
					name: 'stop',
					id: 'stop',
					unicode: 'f04d',
					created: 1,
					categories: [
						'Video Player Icons'
					]
				},
				{
					name: 'forward',
					id: 'forward',
					unicode: 'f04e',
					created: 1,
					categories: [
						'Video Player Icons'
					]
				},
				{
					name: 'fast-forward',
					id: 'fast-forward',
					unicode: 'f050',
					created: 1,
					categories: [
						'Video Player Icons'
					]
				},
				{
					name: 'step-forward',
					id: 'step-forward',
					unicode: 'f051',
					created: 1,
					categories: [
						'Video Player Icons'
					]
				},
				{
					name: 'eject',
					id: 'eject',
					unicode: 'f052',
					created: 1,
					categories: [
						'Video Player Icons'
					]
				},
				{
					name: 'chevron-left',
					id: 'chevron-left',
					unicode: 'f053',
					created: 1,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'chevron-right',
					id: 'chevron-right',
					unicode: 'f054',
					created: 1,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Plus Circle',
					id: 'plus-circle',
					unicode: 'f055',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Minus Circle',
					id: 'minus-circle',
					unicode: 'f056',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Times Circle',
					id: 'times-circle',
					unicode: 'f057',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Check Circle',
					id: 'check-circle',
					unicode: 'f058',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Question Circle',
					id: 'question-circle',
					unicode: 'f059',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Info Circle',
					id: 'info-circle',
					unicode: 'f05a',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Crosshairs',
					id: 'crosshairs',
					unicode: 'f05b',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Times Circle Outlined',
					id: 'times-circle-o',
					unicode: 'f05c',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Check Circle Outlined',
					id: 'check-circle-o',
					unicode: 'f05d',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'ban',
					id: 'ban',
					unicode: 'f05e',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'arrow-left',
					id: 'arrow-left',
					unicode: 'f060',
					created: 1,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'arrow-right',
					id: 'arrow-right',
					unicode: 'f061',
					created: 1,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'arrow-up',
					id: 'arrow-up',
					unicode: 'f062',
					created: 1,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'arrow-down',
					id: 'arrow-down',
					unicode: 'f063',
					created: 1,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Share',
					id: 'share',
					unicode: 'f064',
					created: 1,
					aliases: [
						'mail-forward'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Expand',
					id: 'expand',
					unicode: 'f065',
					created: 1,
					categories: [
						'Video Player Icons'
					]
				},
				{
					name: 'Compress',
					id: 'compress',
					unicode: 'f066',
					created: 1,
					categories: [
						'Video Player Icons'
					]
				},
				{
					name: 'plus',
					id: 'plus',
					unicode: 'f067',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'minus',
					id: 'minus',
					unicode: 'f068',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'asterisk',
					id: 'asterisk',
					unicode: 'f069',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Exclamation Circle',
					id: 'exclamation-circle',
					unicode: 'f06a',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'gift',
					id: 'gift',
					unicode: 'f06b',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'leaf',
					id: 'leaf',
					unicode: 'f06c',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'fire',
					id: 'fire',
					unicode: 'f06d',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Eye',
					id: 'eye',
					unicode: 'f06e',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Eye Slash',
					id: 'eye-slash',
					unicode: 'f070',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Exclamation Triangle',
					id: 'exclamation-triangle',
					unicode: 'f071',
					created: 1,
					aliases: [
						'warning'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'plane',
					id: 'plane',
					unicode: 'f072',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'calendar',
					id: 'calendar',
					unicode: 'f073',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'random',
					id: 'random',
					unicode: 'f074',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'comment',
					id: 'comment',
					unicode: 'f075',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'magnet',
					id: 'magnet',
					unicode: 'f076',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'chevron-up',
					id: 'chevron-up',
					unicode: 'f077',
					created: 1,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'chevron-down',
					id: 'chevron-down',
					unicode: 'f078',
					created: 1,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'retweet',
					id: 'retweet',
					unicode: 'f079',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'shopping-cart',
					id: 'shopping-cart',
					unicode: 'f07a',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Folder',
					id: 'folder',
					unicode: 'f07b',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Folder Open',
					id: 'folder-open',
					unicode: 'f07c',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Arrows Vertical',
					id: 'arrows-v',
					unicode: 'f07d',
					created: 1,
					categories: [
						'Web Application Icons',
						'Directional Icons'
					]
				},
				{
					name: 'Arrows Horizontal',
					id: 'arrows-h',
					unicode: 'f07e',
					created: 1,
					categories: [
						'Web Application Icons',
						'Directional Icons'
					]
				},
				{
					name: 'Bar Chart Outlined',
					id: 'bar-chart-o',
					unicode: 'f080',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Twitter Square',
					id: 'twitter-square',
					unicode: 'f081',
					created: 1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Facebook Square',
					id: 'facebook-square',
					unicode: 'f082',
					created: 1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'camera-retro',
					id: 'camera-retro',
					unicode: 'f083',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'key',
					id: 'key',
					unicode: 'f084',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'cogs',
					id: 'cogs',
					unicode: 'f085',
					created: 1,
					aliases: [
						'gears'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'comments',
					id: 'comments',
					unicode: 'f086',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Thumbs Up Outlined',
					id: 'thumbs-o-up',
					unicode: 'f087',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Thumbs Down Outlined',
					id: 'thumbs-o-down',
					unicode: 'f088',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'star-half',
					id: 'star-half',
					unicode: 'f089',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Heart Outlined',
					id: 'heart-o',
					unicode: 'f08a',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Sign Out',
					id: 'sign-out',
					unicode: 'f08b',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'LinkedIn Square',
					id: 'linkedin-square',
					unicode: 'f08c',
					created: 1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Thumb Tack',
					id: 'thumb-tack',
					unicode: 'f08d',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'External Link',
					id: 'external-link',
					unicode: 'f08e',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Sign In',
					id: 'sign-in',
					unicode: 'f090',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'trophy',
					id: 'trophy',
					unicode: 'f091',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'GitHub Square',
					id: 'github-square',
					unicode: 'f092',
					created: 1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Upload',
					id: 'upload',
					unicode: 'f093',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Lemon Outlined',
					id: 'lemon-o',
					unicode: 'f094',
					created: 1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Phone',
					id: 'phone',
					unicode: 'f095',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Square Outlined',
					id: 'square-o',
					unicode: 'f096',
					created: 2,
					categories: [
						'Web Application Icons',
						'Form Control Icons'
					]
				},
				{
					name: 'Bookmark Outlined',
					id: 'bookmark-o',
					unicode: 'f097',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Phone Square',
					id: 'phone-square',
					unicode: 'f098',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Twitter',
					id: 'twitter',
					unicode: 'f099',
					created: 2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Facebook',
					id: 'facebook',
					unicode: 'f09a',
					created: 2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'GitHub',
					id: 'github',
					unicode: 'f09b',
					created: 2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'unlock',
					id: 'unlock',
					unicode: 'f09c',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'credit-card',
					id: 'credit-card',
					unicode: 'f09d',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'rss',
					id: 'rss',
					unicode: 'f09e',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'HDD',
					id: 'hdd-o',
					unicode: 'f0a0',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'bullhorn',
					id: 'bullhorn',
					unicode: 'f0a1',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'bell',
					id: 'bell',
					unicode: 'f0f3',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'certificate',
					id: 'certificate',
					unicode: 'f0a3',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Hand Outlined Right',
					id: 'hand-o-right',
					unicode: 'f0a4',
					created: 2,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Hand Outlined Left',
					id: 'hand-o-left',
					unicode: 'f0a5',
					created: 2,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Hand Outlined Up',
					id: 'hand-o-up',
					unicode: 'f0a6',
					created: 2,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Hand Outlined Down',
					id: 'hand-o-down',
					unicode: 'f0a7',
					created: 2,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Arrow Circle Left',
					id: 'arrow-circle-left',
					unicode: 'f0a8',
					created: 2,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Arrow Circle Right',
					id: 'arrow-circle-right',
					unicode: 'f0a9',
					created: 2,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Arrow Circle Up',
					id: 'arrow-circle-up',
					unicode: 'f0aa',
					created: 2,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Arrow Circle Down',
					id: 'arrow-circle-down',
					unicode: 'f0ab',
					created: 2,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Globe',
					id: 'globe',
					unicode: 'f0ac',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Wrench',
					id: 'wrench',
					unicode: 'f0ad',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Tasks',
					id: 'tasks',
					unicode: 'f0ae',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Filter',
					id: 'filter',
					unicode: 'f0b0',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Briefcase',
					id: 'briefcase',
					unicode: 'f0b1',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Arrows Alt',
					id: 'arrows-alt',
					unicode: 'f0b2',
					created: 2,
					categories: [
						'Video Player Icons',
						'Directional Icons'
					]
				},
				{
					name: 'Users',
					id: 'users',
					unicode: 'f0c0',
					created: 2,
					aliases: [
						'group'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Link',
					id: 'link',
					unicode: 'f0c1',
					created: 2,
					aliases: [
						'chain'
					],
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'Cloud',
					id: 'cloud',
					unicode: 'f0c2',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Flask',
					id: 'flask',
					unicode: 'f0c3',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Scissors',
					id: 'scissors',
					unicode: 'f0c4',
					created: 2,
					aliases: [
						'cut'
					],
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'Files Outlined',
					id: 'files-o',
					unicode: 'f0c5',
					created: 2,
					aliases: [
						'copy'
					],
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'Paperclip',
					id: 'paperclip',
					unicode: 'f0c6',
					created: 2,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'Floppy Outlined',
					id: 'floppy-o',
					unicode: 'f0c7',
					created: 2,
					aliases: [
						'save'
					],
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'Square',
					id: 'square',
					unicode: 'f0c8',
					created: 2,
					categories: [
						'Web Application Icons',
						'Form Control Icons'
					]
				},
				{
					name: 'Bars',
					id: 'bars',
					unicode: 'f0c9',
					created: 2,
					aliases: [
						'navicon',
						'reorder'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'list-ul',
					id: 'list-ul',
					unicode: 'f0ca',
					created: 2,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'list-ol',
					id: 'list-ol',
					unicode: 'f0cb',
					created: 2,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'Strikethrough',
					id: 'strikethrough',
					unicode: 'f0cc',
					created: 2,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'Underline',
					id: 'underline',
					unicode: 'f0cd',
					created: 2,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'table',
					id: 'table',
					unicode: 'f0ce',
					created: 2,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'magic',
					id: 'magic',
					unicode: 'f0d0',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'truck',
					id: 'truck',
					unicode: 'f0d1',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Pinterest',
					id: 'pinterest',
					unicode: 'f0d2',
					created: 2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Pinterest Square',
					id: 'pinterest-square',
					unicode: 'f0d3',
					created: 2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Google Plus Square',
					id: 'google-plus-square',
					unicode: 'f0d4',
					created: 2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Google Plus',
					id: 'google-plus',
					unicode: 'f0d5',
					created: 2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Money',
					id: 'money',
					unicode: 'f0d6',
					created: 2,
					categories: [
						'Web Application Icons',
						'Currency Icons'
					]
				},
				{
					name: 'Caret Down',
					id: 'caret-down',
					unicode: 'f0d7',
					created: 2,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Caret Up',
					id: 'caret-up',
					unicode: 'f0d8',
					created: 2,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Caret Left',
					id: 'caret-left',
					unicode: 'f0d9',
					created: 2,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Caret Right',
					id: 'caret-right',
					unicode: 'f0da',
					created: 2,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Columns',
					id: 'columns',
					unicode: 'f0db',
					created: 2,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'Sort',
					id: 'sort',
					unicode: 'f0dc',
					created: 2,
					aliases: [
						'unsorted'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Sort Descending',
					id: 'sort-desc',
					unicode: 'f0dd',
					created: 2,
					aliases: [
						'sort-down'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Sort Ascending',
					id: 'sort-asc',
					unicode: 'f0de',
					created: 2,
					aliases: [
						'sort-up'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Envelope',
					id: 'envelope',
					unicode: 'f0e0',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'LinkedIn',
					id: 'linkedin',
					unicode: 'f0e1',
					created: 2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Undo',
					id: 'undo',
					unicode: 'f0e2',
					created: 2,
					aliases: [
						'rotate-left'
					],
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'Gavel',
					id: 'gavel',
					unicode: 'f0e3',
					created: 2,
					aliases: [
						'legal'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Tachometer',
					id: 'tachometer',
					unicode: 'f0e4',
					created: 2,
					aliases: [
						'dashboard'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'comment-o',
					id: 'comment-o',
					unicode: 'f0e5',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'comments-o',
					id: 'comments-o',
					unicode: 'f0e6',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Lightning Bolt',
					id: 'bolt',
					unicode: 'f0e7',
					created: 2,
					aliases: [
						'flash'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Sitemap',
					id: 'sitemap',
					unicode: 'f0e8',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Umbrella',
					id: 'umbrella',
					unicode: 'f0e9',
					created: 2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Clipboard',
					id: 'clipboard',
					unicode: 'f0ea',
					created: 2,
					aliases: [
						'paste'
					],
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'Lightbulb Outlined',
					id: 'lightbulb-o',
					unicode: 'f0eb',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Exchange',
					id: 'exchange',
					unicode: 'f0ec',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Cloud Download',
					id: 'cloud-download',
					unicode: 'f0ed',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Cloud Upload',
					id: 'cloud-upload',
					unicode: 'f0ee',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'user-md',
					id: 'user-md',
					unicode: 'f0f0',
					created: 2,
					categories: [
						'Medical Icons'
					]
				},
				{
					name: 'Stethoscope',
					id: 'stethoscope',
					unicode: 'f0f1',
					created: 3,
					categories: [
						'Medical Icons'
					]
				},
				{
					name: 'Suitcase',
					id: 'suitcase',
					unicode: 'f0f2',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Bell Outlined',
					id: 'bell-o',
					unicode: 'f0a2',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Coffee',
					id: 'coffee',
					unicode: 'f0f4',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Cutlery',
					id: 'cutlery',
					unicode: 'f0f5',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'File Text Outlined',
					id: 'file-text-o',
					unicode: 'f0f6',
					created: 3,
					categories: [
						'Text Editor Icons',
						'File Type Icons'
					]
				},
				{
					name: 'Building Outlined',
					id: 'building-o',
					unicode: 'f0f7',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'hospital Outlined',
					id: 'hospital-o',
					unicode: 'f0f8',
					created: 3,
					categories: [
						'Medical Icons'
					]
				},
				{
					name: 'ambulance',
					id: 'ambulance',
					unicode: 'f0f9',
					created: 3,
					categories: [
						'Medical Icons'
					]
				},
				{
					name: 'medkit',
					id: 'medkit',
					unicode: 'f0fa',
					created: 3,
					categories: [
						'Medical Icons'
					]
				},
				{
					name: 'fighter-jet',
					id: 'fighter-jet',
					unicode: 'f0fb',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'beer',
					id: 'beer',
					unicode: 'f0fc',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'H Square',
					id: 'h-square',
					unicode: 'f0fd',
					created: 3,
					categories: [
						'Medical Icons'
					]
				},
				{
					name: 'Plus Square',
					id: 'plus-square',
					unicode: 'f0fe',
					created: 3,
					categories: [
						'Medical Icons',
						'Web Application Icons',
						'Form Control Icons'
					]
				},
				{
					name: 'Angle Double Left',
					id: 'angle-double-left',
					unicode: 'f100',
					created: 3,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Angle Double Right',
					id: 'angle-double-right',
					unicode: 'f101',
					created: 3,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Angle Double Up',
					id: 'angle-double-up',
					unicode: 'f102',
					created: 3,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Angle Double Down',
					id: 'angle-double-down',
					unicode: 'f103',
					created: 3,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'angle-left',
					id: 'angle-left',
					unicode: 'f104',
					created: 3,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'angle-right',
					id: 'angle-right',
					unicode: 'f105',
					created: 3,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'angle-up',
					id: 'angle-up',
					unicode: 'f106',
					created: 3,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'angle-down',
					id: 'angle-down',
					unicode: 'f107',
					created: 3,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Desktop',
					id: 'desktop',
					unicode: 'f108',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Laptop',
					id: 'laptop',
					unicode: 'f109',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'tablet',
					id: 'tablet',
					unicode: 'f10a',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Mobile Phone',
					id: 'mobile',
					unicode: 'f10b',
					created: 3,
					aliases: [
						'mobile-phone'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Circle Outlined',
					id: 'circle-o',
					unicode: 'f10c',
					created: 3,
					categories: [
						'Web Application Icons',
						'Form Control Icons'
					]
				},
				{
					name: 'quote-left',
					id: 'quote-left',
					unicode: 'f10d',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'quote-right',
					id: 'quote-right',
					unicode: 'f10e',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Spinner',
					id: 'spinner',
					unicode: 'f110',
					created: 3,
					categories: [
						'Web Application Icons',
						'Spinner Icons'
					]
				},
				{
					name: 'Circle',
					id: 'circle',
					unicode: 'f111',
					created: 3,
					categories: [
						'Web Application Icons',
						'Form Control Icons'
					]
				},
				{
					name: 'Reply',
					id: 'reply',
					unicode: 'f112',
					created: 3,
					aliases: [
						'mail-reply'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'GitHub Alt',
					id: 'github-alt',
					unicode: 'f113',
					created: 3,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Folder Outlined',
					id: 'folder-o',
					unicode: 'f114',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Folder Open Outlined',
					id: 'folder-open-o',
					unicode: 'f115',
					created: 3,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Smile Outlined',
					id: 'smile-o',
					unicode: 'f118',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Frown Outlined',
					id: 'frown-o',
					unicode: 'f119',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Meh Outlined',
					id: 'meh-o',
					unicode: 'f11a',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Gamepad',
					id: 'gamepad',
					unicode: 'f11b',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Keyboard Outlined',
					id: 'keyboard-o',
					unicode: 'f11c',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Flag Outlined',
					id: 'flag-o',
					unicode: 'f11d',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'flag-checkered',
					id: 'flag-checkered',
					unicode: 'f11e',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Terminal',
					id: 'terminal',
					unicode: 'f120',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Code',
					id: 'code',
					unicode: 'f121',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'reply-all',
					id: 'reply-all',
					unicode: 'f122',
					created: 3.1,
					aliases: [
						'mail-reply-all'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Star Half Outlined',
					id: 'star-half-o',
					unicode: 'f123',
					created: 3.1,
					aliases: [
						'star-half-empty',
						'star-half-full'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'location-arrow',
					id: 'location-arrow',
					unicode: 'f124',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'crop',
					id: 'crop',
					unicode: 'f125',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'code-fork',
					id: 'code-fork',
					unicode: 'f126',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Chain Broken',
					id: 'chain-broken',
					unicode: 'f127',
					created: 3.1,
					aliases: [
						'unlink'
					],
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'Question',
					id: 'question',
					unicode: 'f128',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Info',
					id: 'info',
					unicode: 'f129',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'exclamation',
					id: 'exclamation',
					unicode: 'f12a',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'superscript',
					id: 'superscript',
					unicode: 'f12b',
					created: 3.1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'subscript',
					id: 'subscript',
					unicode: 'f12c',
					created: 3.1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'eraser',
					id: 'eraser',
					unicode: 'f12d',
					created: 3.1,
					categories: [
						'Text Editor Icons',
						'Web Application Icons'
					]
				},
				{
					name: 'Puzzle Piece',
					id: 'puzzle-piece',
					unicode: 'f12e',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'microphone',
					id: 'microphone',
					unicode: 'f130',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Microphone Slash',
					id: 'microphone-slash',
					unicode: 'f131',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'shield',
					id: 'shield',
					unicode: 'f132',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'calendar-o',
					id: 'calendar-o',
					unicode: 'f133',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'fire-extinguisher',
					id: 'fire-extinguisher',
					unicode: 'f134',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'rocket',
					id: 'rocket',
					unicode: 'f135',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'MaxCDN',
					id: 'maxcdn',
					unicode: 'f136',
					created: 3.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Chevron Circle Left',
					id: 'chevron-circle-left',
					unicode: 'f137',
					created: 3.1,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Chevron Circle Right',
					id: 'chevron-circle-right',
					unicode: 'f138',
					created: 3.1,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Chevron Circle Up',
					id: 'chevron-circle-up',
					unicode: 'f139',
					created: 3.1,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Chevron Circle Down',
					id: 'chevron-circle-down',
					unicode: 'f13a',
					created: 3.1,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'HTML 5 Logo',
					id: 'html5',
					unicode: 'f13b',
					created: 3.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'CSS 3 Logo',
					id: 'css3',
					unicode: 'f13c',
					created: 3.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Anchor',
					id: 'anchor',
					unicode: 'f13d',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Unlock Alt',
					id: 'unlock-alt',
					unicode: 'f13e',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Bullseye',
					id: 'bullseye',
					unicode: 'f140',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Ellipsis Horizontal',
					id: 'ellipsis-h',
					unicode: 'f141',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Ellipsis Vertical',
					id: 'ellipsis-v',
					unicode: 'f142',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'RSS Square',
					id: 'rss-square',
					unicode: 'f143',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Play Circle',
					id: 'play-circle',
					unicode: 'f144',
					created: 3.1,
					categories: [
						'Video Player Icons'
					]
				},
				{
					name: 'Ticket',
					id: 'ticket',
					unicode: 'f145',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Minus Square',
					id: 'minus-square',
					unicode: 'f146',
					created: 3.1,
					categories: [
						'Web Application Icons',
						'Form Control Icons'
					]
				},
				{
					name: 'Minus Square Outlined',
					id: 'minus-square-o',
					unicode: 'f147',
					created: 3.1,
					categories: [
						'Web Application Icons',
						'Form Control Icons'
					]
				},
				{
					name: 'Level Up',
					id: 'level-up',
					unicode: 'f148',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Level Down',
					id: 'level-down',
					unicode: 'f149',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Check Square',
					id: 'check-square',
					unicode: 'f14a',
					created: 3.1,
					categories: [
						'Web Application Icons',
						'Form Control Icons'
					]
				},
				{
					name: 'Pencil Square',
					id: 'pencil-square',
					unicode: 'f14b',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'External Link Square',
					id: 'external-link-square',
					unicode: 'f14c',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Share Square',
					id: 'share-square',
					unicode: 'f14d',
					created: 3.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Compass',
					id: 'compass',
					unicode: 'f14e',
					created: 3.2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Caret Square Outlined Down',
					id: 'caret-square-o-down',
					unicode: 'f150',
					created: 3.2,
					aliases: [
						'toggle-down'
					],
					categories: [
						'Web Application Icons',
						'Directional Icons'
					]
				},
				{
					name: 'Caret Square Outlined Up',
					id: 'caret-square-o-up',
					unicode: 'f151',
					created: 3.2,
					aliases: [
						'toggle-up'
					],
					categories: [
						'Web Application Icons',
						'Directional Icons'
					]
				},
				{
					name: 'Caret Square Outlined Right',
					id: 'caret-square-o-right',
					unicode: 'f152',
					created: 3.2,
					aliases: [
						'toggle-right'
					],
					categories: [
						'Web Application Icons',
						'Directional Icons'
					]
				},
				{
					name: 'Euro (EUR)',
					id: 'eur',
					unicode: 'f153',
					created: 3.2,
					aliases: [
						'euro'
					],
					categories: [
						'Currency Icons'
					]
				},
				{
					name: 'GBP',
					id: 'gbp',
					unicode: 'f154',
					created: 3.2,
					categories: [
						'Currency Icons'
					]
				},
				{
					name: 'US Dollar',
					id: 'usd',
					unicode: 'f155',
					created: 3.2,
					aliases: [
						'dollar'
					],
					categories: [
						'Currency Icons'
					]
				},
				{
					name: 'Indian Rupee (INR)',
					id: 'inr',
					unicode: 'f156',
					created: 3.2,
					aliases: [
						'rupee'
					],
					categories: [
						'Currency Icons'
					]
				},
				{
					name: 'Japanese Yen (JPY)',
					id: 'jpy',
					unicode: 'f157',
					created: 3.2,
					aliases: [
						'cny',
						'rmb',
						'yen'
					],
					categories: [
						'Currency Icons'
					]
				},
				{
					name: 'Russian Ruble (RUB)',
					id: 'rub',
					unicode: 'f158',
					created: 4,
					aliases: [
						'ruble',
						'rouble'
					],
					categories: [
						'Currency Icons'
					]
				},
				{
					name: 'Korean Won (KRW)',
					id: 'krw',
					unicode: 'f159',
					created: 3.2,
					aliases: [
						'won'
					],
					categories: [
						'Currency Icons'
					]
				},
				{
					name: 'Bitcoin (BTC)',
					id: 'btc',
					unicode: 'f15a',
					created: 3.2,
					aliases: [
						'bitcoin'
					],
					categories: [
						'Currency Icons',
						'Brand Icons'
					]
				},
				{
					name: 'File',
					id: 'file',
					unicode: 'f15b',
					created: 3.2,
					categories: [
						'Text Editor Icons',
						'File Type Icons'
					]
				},
				{
					name: 'File Text',
					id: 'file-text',
					unicode: 'f15c',
					created: 3.2,
					categories: [
						'Text Editor Icons',
						'File Type Icons'
					]
				},
				{
					name: 'Sort Alpha Ascending',
					id: 'sort-alpha-asc',
					unicode: 'f15d',
					created: 3.2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Sort Alpha Descending',
					id: 'sort-alpha-desc',
					unicode: 'f15e',
					created: 3.2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Sort Amount Ascending',
					id: 'sort-amount-asc',
					unicode: 'f160',
					created: 3.2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Sort Amount Descending',
					id: 'sort-amount-desc',
					unicode: 'f161',
					created: 3.2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Sort Numeric Ascending',
					id: 'sort-numeric-asc',
					unicode: 'f162',
					created: 3.2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Sort Numeric Descending',
					id: 'sort-numeric-desc',
					unicode: 'f163',
					created: 3.2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'thumbs-up',
					id: 'thumbs-up',
					unicode: 'f164',
					created: 3.2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'thumbs-down',
					id: 'thumbs-down',
					unicode: 'f165',
					created: 3.2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'YouTube Square',
					id: 'youtube-square',
					unicode: 'f166',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'YouTube',
					id: 'youtube',
					unicode: 'f167',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Xing',
					id: 'xing',
					unicode: 'f168',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Xing Square',
					id: 'xing-square',
					unicode: 'f169',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'YouTube Play',
					id: 'youtube-play',
					unicode: 'f16a',
					created: 3.2,
					categories: [
						'Brand Icons',
						'Video Player Icons'
					]
				},
				{
					name: 'Dropbox',
					id: 'dropbox',
					unicode: 'f16b',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Stack Overflow',
					id: 'stack-overflow',
					unicode: 'f16c',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Instagram',
					id: 'instagram',
					unicode: 'f16d',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Flickr',
					id: 'flickr',
					unicode: 'f16e',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'App.net',
					id: 'adn',
					unicode: 'f170',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Bitbucket',
					id: 'bitbucket',
					unicode: 'f171',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Bitbucket Square',
					id: 'bitbucket-square',
					unicode: 'f172',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Tumblr',
					id: 'tumblr',
					unicode: 'f173',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Tumblr Square',
					id: 'tumblr-square',
					unicode: 'f174',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Long Arrow Down',
					id: 'long-arrow-down',
					unicode: 'f175',
					created: 3.2,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Long Arrow Up',
					id: 'long-arrow-up',
					unicode: 'f176',
					created: 3.2,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Long Arrow Left',
					id: 'long-arrow-left',
					unicode: 'f177',
					created: 3.2,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Long Arrow Right',
					id: 'long-arrow-right',
					unicode: 'f178',
					created: 3.2,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Apple',
					id: 'apple',
					unicode: 'f179',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Windows',
					id: 'windows',
					unicode: 'f17a',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Android',
					id: 'android',
					unicode: 'f17b',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Linux',
					id: 'linux',
					unicode: 'f17c',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Dribbble',
					id: 'dribbble',
					unicode: 'f17d',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Skype',
					id: 'skype',
					unicode: 'f17e',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Foursquare',
					id: 'foursquare',
					unicode: 'f180',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Trello',
					id: 'trello',
					unicode: 'f181',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Female',
					id: 'female',
					unicode: 'f182',
					created: 3.2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Male',
					id: 'male',
					unicode: 'f183',
					created: 3.2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Gittip',
					id: 'gittip',
					unicode: 'f184',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Sun Outlined',
					id: 'sun-o',
					unicode: 'f185',
					created: 3.2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Moon Outlined',
					id: 'moon-o',
					unicode: 'f186',
					created: 3.2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Archive',
					id: 'archive',
					unicode: 'f187',
					created: 3.2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Bug',
					id: 'bug',
					unicode: 'f188',
					created: 3.2,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'VK',
					id: 'vk',
					unicode: 'f189',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Weibo',
					id: 'weibo',
					unicode: 'f18a',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Renren',
					id: 'renren',
					unicode: 'f18b',
					created: 3.2,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Pagelines',
					id: 'pagelines',
					unicode: 'f18c',
					created: 4,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Stack Exchange',
					id: 'stack-exchange',
					unicode: 'f18d',
					created: 4,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Arrow Circle Outlined Right',
					id: 'arrow-circle-o-right',
					unicode: 'f18e',
					created: 4,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Arrow Circle Outlined Left',
					id: 'arrow-circle-o-left',
					unicode: 'f190',
					created: 4,
					categories: [
						'Directional Icons'
					]
				},
				{
					name: 'Caret Square Outlined Left',
					id: 'caret-square-o-left',
					unicode: 'f191',
					created: 4,
					aliases: [
						'toggle-left'
					],
					categories: [
						'Web Application Icons',
						'Directional Icons'
					]
				},
				{
					name: 'Dot Circle O',
					id: 'dot-circle-o',
					unicode: 'f192',
					created: 4,
					categories: [
						'Web Application Icons',
						'Form Control Icons'
					]
				},
				{
					name: 'Wheelchair',
					id: 'wheelchair',
					unicode: 'f193',
					created: 4,
					categories: [
						'Web Application Icons',
						'Medical Icons'
					]
				},
				{
					name: 'Vimeo Square',
					id: 'vimeo-square',
					unicode: 'f194',
					created: 4,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Turkish Lira (TRY)',
					id: 'try',
					unicode: 'f195',
					created: 4,
					aliases: [
						'turkish-lira'
					],
					categories: [
						'Currency Icons'
					]
				},
				{
					name: 'Plus Square Outlined',
					id: 'plus-square-o',
					unicode: 'f196',
					created: 4,
					categories: [
						'Web Application Icons',
						'Form Control Icons'
					]
				},
				{
					name: 'Space Shuttle',
					id: 'space-shuttle',
					unicode: 'f197',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Slack Logo',
					id: 'slack',
					unicode: 'f198',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Envelope Square',
					id: 'envelope-square',
					unicode: 'f199',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Wordpress Logo',
					id: 'wordpress',
					unicode: 'f19a',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'OpenID',
					id: 'openid',
					unicode: 'f19b',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'University',
					id: 'university',
					unicode: 'f19c',
					created: 4.1,
					aliases: [
						'institution',
						'bank'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Graduation Cap',
					id: 'graduation-cap',
					unicode: 'f19d',
					created: 4.1,
					aliases: [
						'mortar-board'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Yahoo Logo',
					id: 'yahoo',
					unicode: 'f19e',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Google Logo',
					id: 'google',
					unicode: 'f1a0',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'reddit Logo',
					id: 'reddit',
					unicode: 'f1a1',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'reddit Square',
					id: 'reddit-square',
					unicode: 'f1a2',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'StumbleUpon Circle',
					id: 'stumbleupon-circle',
					unicode: 'f1a3',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'StumbleUpon Logo',
					id: 'stumbleupon',
					unicode: 'f1a4',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Delicious Logo',
					id: 'delicious',
					unicode: 'f1a5',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Digg Logo',
					id: 'digg',
					unicode: 'f1a6',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Pied Piper Logo',
					id: 'pied-piper',
					unicode: 'f1a7',
					created: 4.1,
					categories: [
						'Brand Icons'
					],
					aliases: [
						'pied-piper-square'
					]
				},
				{
					name: 'Pied Piper Alternate Logo',
					id: 'pied-piper-alt',
					unicode: 'f1a8',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Drupal Logo',
					id: 'drupal',
					unicode: 'f1a9',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Joomla Logo',
					id: 'joomla',
					unicode: 'f1aa',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Language',
					id: 'language',
					unicode: 'f1ab',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Fax',
					id: 'fax',
					unicode: 'f1ac',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Building',
					id: 'building',
					unicode: 'f1ad',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Child',
					id: 'child',
					unicode: 'f1ae',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Paw',
					id: 'paw',
					unicode: 'f1b0',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'spoon',
					id: 'spoon',
					unicode: 'f1b1',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Cube',
					id: 'cube',
					unicode: 'f1b2',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Cubes',
					id: 'cubes',
					unicode: 'f1b3',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Behance',
					id: 'behance',
					unicode: 'f1b4',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Behance Square',
					id: 'behance-square',
					unicode: 'f1b5',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Steam',
					id: 'steam',
					unicode: 'f1b6',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Steam Square',
					id: 'steam-square',
					unicode: 'f1b7',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Recycle',
					id: 'recycle',
					unicode: 'f1b8',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Car',
					id: 'car',
					unicode: 'f1b9',
					created: 4.1,
					categories: [
						'Web Application Icons'
					],
					aliases: [
						'automobile'
					]
				},
				{
					name: 'Taxi',
					id: 'taxi',
					unicode: 'f1ba',
					created: 4.1,
					categories: [
						'Web Application Icons'
					],
					aliases: [
						'cab'
					]
				},
				{
					name: 'Tree',
					id: 'tree',
					unicode: 'f1bb',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Spotify',
					id: 'spotify',
					unicode: 'f1bc',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'deviantART',
					id: 'deviantart',
					unicode: 'f1bd',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'SoundCloud',
					id: 'soundcloud',
					unicode: 'f1be',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Database',
					id: 'database',
					unicode: 'f1c0',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'PDF File Outlined',
					id: 'file-pdf-o',
					unicode: 'f1c1',
					created: 4.1,
					categories: [
						'Web Application Icons',
						'File Type Icons'
					]
				},
				{
					name: 'Word File Outlined',
					id: 'file-word-o',
					unicode: 'f1c2',
					created: 4.1,
					categories: [
						'Web Application Icons',
						'File Type Icons'
					]
				},
				{
					name: 'Excel File Outlined',
					id: 'file-excel-o',
					unicode: 'f1c3',
					created: 4.1,
					categories: [
						'Web Application Icons',
						'File Type Icons'
					]
				},
				{
					name: 'Powerpoint File Outlined',
					id: 'file-powerpoint-o',
					unicode: 'f1c4',
					created: 4.1,
					categories: [
						'Web Application Icons',
						'File Type Icons'
					]
				},
				{
					name: 'Image File Outlined',
					id: 'file-image-o',
					unicode: 'f1c5',
					created: 4.1,
					aliases: [
						'file-photo-o',
						'file-picture-o'
					],
					categories: [
						'Web Application Icons',
						'File Type Icons'
					]
				},
				{
					name: 'Archive File Outlined',
					id: 'file-archive-o',
					unicode: 'f1c6',
					created: 4.1,
					aliases: [
						'file-zip-o'
					],
					categories: [
						'Web Application Icons',
						'File Type Icons'
					]
				},
				{
					name: 'Audio File Outlined',
					id: 'file-audio-o',
					unicode: 'f1c7',
					created: 4.1,
					aliases: [
						'file-sound-o'
					],
					categories: [
						'Web Application Icons',
						'File Type Icons'
					]
				},
				{
					name: 'Video File Outlined',
					id: 'file-video-o',
					unicode: 'f1c8',
					created: 4.1,
					aliases: [
						'file-movie-o'
					],
					categories: [
						'Web Application Icons',
						'File Type Icons'
					]
				},
				{
					name: 'Code File Outlined',
					id: 'file-code-o',
					unicode: 'f1c9',
					created: 4.1,
					categories: [
						'Web Application Icons',
						'File Type Icons'
					]
				},
				{
					name: 'Vine',
					id: 'vine',
					unicode: 'f1ca',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Codepen',
					id: 'codepen',
					unicode: 'f1cb',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'jsFiddle',
					id: 'jsfiddle',
					unicode: 'f1cc',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Life Ring',
					id: 'life-ring',
					unicode: 'f1cd',
					created: 4.1,
					aliases: [
						'life-bouy',
						'life-saver',
						'support'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Circle Outlined Notched',
					id: 'circle-o-notch',
					unicode: 'f1ce',
					created: 4.1,
					categories: [
						'Web Application Icons',
						'Spinner Icons'
					]
				},
				{
					name: 'Rebel Alliance',
					id: 'rebel',
					unicode: 'f1d0',
					created: 4.1,
					aliases: [
						'ra'
					],
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Galactic Empire',
					id: 'empire',
					unicode: 'f1d1',
					created: 4.1,
					aliases: [
						'ge'
					],
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Git Square',
					id: 'git-square',
					unicode: 'f1d2',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Git',
					id: 'git',
					unicode: 'f1d3',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Hacker News',
					id: 'hacker-news',
					unicode: 'f1d4',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Tencent Weibo',
					id: 'tencent-weibo',
					unicode: 'f1d5',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'QQ',
					id: 'qq',
					unicode: 'f1d6',
					created: 4.1,
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Weixin (WeChat)',
					id: 'weixin',
					unicode: 'f1d7',
					created: 4.1,
					aliases: [
						'wechat'
					],
					categories: [
						'Brand Icons'
					]
				},
				{
					name: 'Paper Plane',
					id: 'paper-plane',
					unicode: 'f1d8',
					created: 4.1,
					aliases: [
						'send'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Paper Plane Outlined',
					id: 'paper-plane-o',
					unicode: 'f1d9',
					created: 4.1,
					aliases: [
						'send-o'
					],
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'History',
					id: 'history',
					unicode: 'f1da',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Circle Outlined Thin',
					id: 'circle-thin',
					unicode: 'f1db',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'header',
					id: 'header',
					unicode: 'f1dc',
					created: 4.1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'paragraph',
					id: 'paragraph',
					unicode: 'f1dd',
					created: 4.1,
					categories: [
						'Text Editor Icons'
					]
				},
				{
					name: 'Sliders',
					id: 'sliders',
					unicode: 'f1de',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				},
				{
					name: 'Share Alt',
					id: 'share-alt',
					unicode: 'f1e0',
					created: 4.1,
					categories: [
						'Web Application Icons',
						'Brand Icons'
					]
				},
				{
					name: 'Share Alt Square',
					id: 'share-alt-square',
					unicode: 'f1e1',
					created: 4.1,
					categories: [
						'Web Application Icons',
						'Brand Icons'
					]
				},
				{
					name: 'Bomb',
					id: 'bomb',
					unicode: 'f1e2',
					created: 4.1,
					categories: [
						'Web Application Icons'
					]
				}
			]
		}
	},
	computed: {
		listado () {
			if (!this.filtro) {
				return this.iconos
			}
			const regexp = new RegExp(this.filtro, 'ig')
			return this.iconos.filter((icono) => regexp.test(icono.name))
		}
	},
	methods: {
		seleccionar (icono) {
			this.$emit('seleccion', `fa fa-${icono.id}`)
			this.$emit('close')
		}
	}
}
</script>

<style scoped>
.contenedor-iconos {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
}
.icono {
	position: relative;
	text-align: center;
	font-size: 2rem;
	margin: 1rem;
	flex-basis: 40px;
	opacity: 0.5;
	cursor: pointer;
}

.icono:hover {
	opacity: 1;
}

.icono div {
	font-size: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// src/modulos/muro/vue/componentes/alertas/seleccion-icono.vue